import { QuoteCard } from './quote-card.component';
export * from './quote-card.component';
export default QuoteCard;

QuoteCard.define('quote-card');

declare global {
    interface HTMLElementTagNameMap {
        'quote-card': QuoteCard;
    }
}
